import { useEffect, useRef, useState } from 'react';

export type ElementSize = { width: number; height: number };

export function useElementSize<T extends HTMLElement>() {
  const ref = useRef<T | null>(null);
  const [size, setSize] = useState<ElementSize>({ width: 0, height: 0 });

  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }

    const updateSize = () => {
      setSize({
        width: Math.max(0, Math.floor(node.clientWidth)),
        height: Math.max(0, Math.floor(node.clientHeight)),
      });
    };

    updateSize();

    const observer = new ResizeObserver(() => {
      updateSize();
    });
    observer.observe(node);

    return () => {
      observer.disconnect();
    };
  }, []);

  return { ref, size };
}
